import type { Node } from '@xyflow/react';
import { NodeEditModeEnum } from '../../workflow-sidebar/edit-node-form/edit-node-form.types';

export enum NodeType {
  Enroll = 'enroll',
  Wait = 'wait',
  Action = 'action',
}

export enum StaticNodeType {
  Add = 'add',
  Start = 'start',
}

export type SidebarView =
  | { kind: NodeEditModeEnum.Library }
  | { kind: NodeEditModeEnum.EditExisting; node: Node }
  | { kind: NodeEditModeEnum.EditDraft; node: Node };

export type WorkflowSidebarControlProps = {
  open: boolean;
  close: () => void;
  view: SidebarView;
  backToLibrary: () => void;
  addDraftNode: (nodeType: NodeType.Wait | NodeType.Action) => void;
  saveDraftNode: (data: Record<string, unknown>) => void;
  saveExistingNode: (data: Record<string, unknown>) => void;
};
